import styled from 'styled-components';
import color from 'tinycolor2';
import { Menu as MenuComponent } from '@pearsontechnology/aero-components';

import {
  PageNavItem,
} from 'components/PageStyles';

export const Nav = styled(PageNavItem)`
  justify-content: left;
  font-size: 16px;
  line-height: 19px;
  font-weight: normal;
  margin-bottom: 5px;

  color: ${(props) => props.theme['color.text.body']};

  &:hover {
    outline: none;
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.05).toString()};
  }

  ${(props) => props.active && `
    color: ${props.theme['color.primary']};

    &:hover {
      background: none;
    }
  `}
`;

export const IconLeft = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: ${(props) => props.active ? props.theme['color.primary'] : props.theme['color.text.light']};
`;

export const IconRight = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme['color.text.light']};
`;

export const SubscriptionPlaceholder = styled.div`
  padding: 30px 22px 15px 19px;
`;

export const SubscriptionInner = styled(Nav)`
  justify-content: space-between;
  color: ${(props) => props.theme['color.text.body']};

  &:hover {
    outline: none;
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.05).toString()};
  }
`;

export const SubscriptionContent = styled.div`
  display: flex;
  align-content: center;
`;

export const Menu = styled(MenuComponent)`
  margin-top: 45px;
  width: 219px;
  max-height: 99vh;
  overflow-y: auto;
  scrollbar-width: thin;
  ::-webkit-scrollbar {
    width: 8px;
    height : 30px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 6px;
  }
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #888; 
}
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  justify-content: space-between;
  font-size: 14px;
  height: 30px;
  color: ${(props) => props.theme['color.text.body']};
  cursor: pointer;

  ${(props) => props.selected && `
    background-color: ${color(props.theme['color.primary.text']).setAlpha(0.1).toString()};
    color: ${props.theme['color.primary.text']};
    border-radius: 4px;
  `}
`;

export const MenuItemTitle = styled.span`
  line-height: 18px;
`;
